module.exports = __webpack_public_path__ + "static/media/sow-section-2bg.589eef0d.svg";